export default {
  sidebar: {
    wallet: 'Кошелёк',
    transactions: 'Транзакции',
    logout: 'Выход',
  },
  home: {
    currentBalance: 'Текущий баланс кошелька:',
    updatedAt: 'Обновлено:',
    columns: {
      amountYesterday: 'Баланс за вчерашний день',
      amountToday: 'Баланс на сегодня',
      paidAmount: 'Сумма списаний',
      addBalance: 'Пополнение кошелька',
      refundedAmount: 'Сумма возвратов',
      date: 'Дата',
    },
  },
  transactions: {
    columns: {
      agent: 'Агент',
      phone: 'Номер телефона',
      amount: 'Сумма',
      transactionType: 'Тип транзакции',
      statusDescription: 'Описание статуса',
      updatedAt: 'Дата обновления',
    },
  },
  table: {
    pageSize: 'Размер страницы',
    datePlaceholder: 'Введите дату',
    export: 'Экспорт',
    of: 'из',
    errorLoading: 'Ошибка загрузки данных для таблицы!',
  },
}
